import React from 'react';
import { PropertyBuildingCardProps } from '../../../common/typings';
import { Card, Button } from 'antd';
import Meta from 'antd/lib/card/Meta';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import houseSquare from '../../../images/house_square_footage.svg';
import bathroom from '../../../images/bathroom.svg';
import bedroom from '../../../images/bedroom.svg';
import square from '../../../images/square.svg';
import { CardBanners } from '../cardBanners/card-banners';

export const RealEstateCard: React.FC<PropertyBuildingCardProps> = (props: PropertyBuildingCardProps) => {
	const { t } = useTranslation();
	const history = useHistory();
	const { id, cover, loading, location, rooms, bathrooms, squareMetres , houseSquareMetres, price, isBought, isReserved, isNewListing } = props;

	const routeChange = () =>{
		let path = `/house?id=` + id;

		history.push(path);
	}

	return (
		<div className="featured-card">
			<Card
				className="card"
				hoverable
				loading={loading}
				cover={
					<a href="javascript:void(0)" onClick={routeChange}><img alt="house cover" src={cover} /></a>
				}
			>
				<Meta
					title={id}
					description={location}
				/>
				<Button
					onClick={routeChange}
					className="btn"
					type="primary"
					block
				>
					{t("card.action")}
				</Button>
				<div className="info">
					<div className="rows">
						<div className="featured-detail square">
							<img width={25} src={houseSquare} alt="houseSquare" />
							<p className="category right"><span>{houseSquareMetres}</span> m2</p>
						</div>
						<p className="category center">|</p>
						<div className="featured-detail right">
							<img width={25} src={bedroom} alt="bedrooms" />
							<p className="category right"><span>{rooms}</span></p>
						</div>
					</div>
					<div className="rows">
						<div className="featured-detail full-square">
							<img width={25} src={square} alt="square" />
							<p className="category"><span>{squareMetres}</span> m2</p>
						</div>
						<p className="category center">|</p>
						<div className="featured-detail right">
							<img width={25} src={bathroom} alt="bathrooms" />
							<p className="category right"><span>{bathrooms}</span></p>
						</div>
					</div>
				</div>
				<p className="text-center"><span>{price}</span> €</p>
				<CardBanners
					isBought={isBought}
					isReserved={isReserved}
					isNewListing={isNewListing}
				/>
			</Card>
		</div>
	);
};
